import { render, staticRenderFns } from "./OrganizationPage.vue?vue&type=template&id=3aa5c97c&scoped=true"
import script from "./OrganizationPage.vue?vue&type=script&lang=js"
export * from "./OrganizationPage.vue?vue&type=script&lang=js"
import style0 from "./OrganizationPage.vue?vue&type=style&index=0&id=3aa5c97c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa5c97c",
  null
  
)

export default component.exports